'use client';

import React, { useEffect, useState } from 'react';
import initTranslations from '@/i18n';
import TranslationsProvider from '@/i18n/TranslationsProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Resource } from 'i18next';
import StoreProvider from './StoreProviders';
import theme from '@/theme';

const I18N_NAMESPACES = ['common'];

export function ThemeProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}


type ProvidersClientProps = {
  children: React.ReactNode;
  params: {
    locale: string;
  };
};

const AppContent: React.FC<{ children: React.ReactNode; locale: string }> = ({
  children,
  locale,
}) => {
  const [resources, setResources] = useState<Resource>({});

  // Load translations when locale changes
  useEffect(() => {
    (async () => {
      try {
        const translations = await initTranslations(locale, I18N_NAMESPACES);
        console.log('Translations loaded:', translations);
        setResources(translations.resources);
      } catch (error) {
        console.error('Error loading translations:', error);
      }
    })();
  }, [locale]);


  return (
    <TranslationsProvider namespaces={I18N_NAMESPACES} locale={locale} resources={resources}>
      <ThemeProviders>
        {children}</ThemeProviders>
    </TranslationsProvider>
  );
};

export const ProvidersClient: React.FC<ProvidersClientProps> = ({ children, params }) => (
  <StoreProvider>
    <AppContent locale={params.locale}>{children}</AppContent>
  </StoreProvider>
);

export default ProvidersClient;
